import {
  CreateDatasetTableRequest,
  CreateTableResponse,
  DatasetTablesControllerApi,
  GetTableListResponse,
  UpdateDatasetTableRequest,
  UpdateTableResponse,
} from './generated'
import { REQUEST_OPTIONS } from './_configs'

const tableApiClient = new DatasetTablesControllerApi()

export const getDatasetTables = async (datasetId: string): Promise<GetTableListResponse> => {
  return tableApiClient.getDatasetTableList({ datasetId }, REQUEST_OPTIONS)
}

export type UpdateDatasetTableParams = {
  tableVersion: number
  tableName: string
  tableDescription: string
  tableSynonyms: string[]
  joinedTableIds: string[]
  isActive?: boolean
}

export const updateDatasetTable = async (
  tableId: string,
  datasetId: string,
  force: boolean,
  params: UpdateDatasetTableParams,
): Promise<UpdateTableResponse> => {
  const body: UpdateDatasetTableRequest = {
    datasetId,
    tableId,
    force,
    updateTableRequest: {
      ...params,
      isActive: params.isActive,
    },
  }
  return tableApiClient.updateDatasetTable(body, REQUEST_OPTIONS)
}

export const createDatasetTable = async (
  datasetId: string,
  createTableRequest: CreateDatasetTableRequest['createTableRequest'] & { isActive?: boolean },
): Promise<CreateTableResponse> => {
  const body: CreateDatasetTableRequest = {
    datasetId,
    createTableRequest: {
      ...createTableRequest,
      isActive: createTableRequest.isActive ?? true,
    },
  }
  return tableApiClient.createDatasetTable(body, REQUEST_OPTIONS)
}

export const deleteDatasetTable = async (datasetId: string, tableId: string, force: boolean): Promise<any> => {
  return tableApiClient.deleteDatasetTableRaw({ datasetId, tableId, force }, REQUEST_OPTIONS)
}
